import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import '/Users/montassarghanmy/Documents/player_v6/node_modules/css-loader/dist/runtime/api.js'
import '/Users/montassarghanmy/Documents/player_v6/node_modules/vue-style-loader/lib/addStylesShadow.js'
import '/Users/montassarghanmy/Documents/player_v6/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js'

import empPlayer from '~root/src/App.vue?shadow'
window.customElements.define('emp-player', wrap(Vue, empPlayer))